/** The shared no-op callback — one identity reused wherever a component needs a
 *  stable "do nothing" handler (presentational Switches, unmanaged toggles). */
export const noop = (): void => {};
